export default "__VITE_ASSET__BbSmaB_Q__"